/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-15 11:27:55
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 15:05:52
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/ProductSelectionWithHsCode/SpecificProducts/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Button } from 'src/components/Antd';
import ProductSelection from 'src/constrains/ProductsSelection/ProductsSelection';
import TagGroup from 'src/components/TagGroup/TagGroup';
import { EnumProductProperty } from 'src/types/common/product';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { EnumProductType } from 'src/types/common/product';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Specific = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const columns = [
    {
      title: '',
      dataIndex: 'thumbnailUrl',
      key: 'thumbnailUrl',
      default: true,
      optional: false,

      render: (url, record) => {
        return <img width={40} height={40} key={url} src={url} alt={url} />;
      },
      width: 64,
    },
    {
      title: getI18n('general.sKU'),
      dataIndex: 'sku',
      default: true,
      optional: true,
      key: 'sku',

      minWidth: 120,
    },
    {
      title: getI18n('general.productName'),
      dataIndex: 'name',
      default: true,
      optional: true,
      key: 'name',

      minWidth: 180,
    },
    {
      title: getI18n('general.type'),
      dataIndex: 'productType',
      default: true,
      optional: true,
      key: 'productType',

      minWidth: 110,
    },
    {
      title: getI18n('general.remarks'),
      dataIndex: 'remarks',
      default: true,
      optional: true,
      key: 'remarks',

      minWidth: 110,
    },

    {
      title: getI18n('general.tags'),
      dataIndex: 'tags',
      default: true,
      optional: true,
      align: 'center',

      key: 'tags',
      minWidth: 150,
      tags: true,
      tagsGenerator: (
        characterLength,
        width,
        marginPaddingWidth,
        containPaddingWidth,
        tags,
        record,
      ) => {
        return (
          <TagGroup
            characterLength={characterLength}
            containerWidth={width}
            marginPaddingWidth={marginPaddingWidth}
            containPaddingWidth={containPaddingWidth}
            tags={tags}
          />
        );
      },
    },
  ];
  const [visible, setVisible] = React.useState(false);
  const { products, onProductsChange, error } = props;
  const onCancel = () => {
    setVisible(false);
  };
  const onOk = (products = []) => {
    if (onProductsChange) onProductsChange(products);
    //   const _pWithDraggableId = products.map((i) => {
    //     const { uuid } = i;
    //     return { ...i, draggableId: uuid };
    //   });
    //   onChange(_pWithDraggableId);
  };
  return (
    <div className={css.container}>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={onCancel}
          onOk={onOk}
          selectedItems={products}
          columns={columns}
          fixedSearchConditions={{ category: EnumProductProperty.Physical }}
          hideDefaultTypeFilter
          extraFilters={[
            {
              type: EnumFilterType.MultipleSelection,
              dropdownProps: { name: getI18n('general.type') },
              keyWord: 'productTypes',
              options: [
                //定义排序所需的数据
                {
                  label: getI18n('general.simple'),
                  value: EnumProductType.Simple,
                },
                { label: getI18n('general.set'), value: EnumProductType.Set },
              ],
            },
          ]}
        />
      )}
      <Button
        type='primary'
        className={css.btn}
        onClick={() => setVisible(true)}>
        {getI18n('general.addProducts')}
      </Button>
      {error && <div className={css.errContainer}>{error}</div>}
    </div>
  );
};
export default Specific;
